import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CONTACT } from "../content";
import { CTAButton, Reveal } from "./ui-bits";

const NAV = [
    { to: "/how-it-works", label: "How It Works" },
    { to: "/services", label: "Services" },
    { to: "/compliance-guide", label: "Compliance Guide" },
    { to: "/about", label: "About" },
    { to: "/get-started", label: "Get Started" },
];

export function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-ink text-bone">
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="border-b border-boneline py-24 md:py-32">
                    <Reveal>
                        <p className="mb-6 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-bone/60">
                            <span className="inline-block h-2.5 w-2.5 bg-volt" />
                            Ready when you are
                        </p>
                        <h2 className="max-w-4xl font-display text-5xl font-bold leading-[0.95] tracking-tighter md:text-7xl">
                            Make every door
                            <br />
                            <span className="text-volt">compliant.</span>
                        </h2>
                        <div className="mt-10 flex flex-wrap items-center gap-4">
                            <CTAButton to="/get-started" variant="volt" testid="footer-cta-quote">
                                Get a 48-hour quote
                            </CTAButton>
                            <a
                                href={`tel:${CONTACT.phone.replace(/[^0-9]/g, "")}`}
                                data-testid="footer-phone-cta"
                                className="group inline-flex items-center gap-2 rounded-full border border-boneline px-7 py-4 font-display text-sm font-bold uppercase tracking-widest transition-[border-color,color] duration-300 hover:border-volt hover:text-volt"
                            >
                                {CONTACT.phone}
                            </a>
                        </div>
                    </Reveal>
                </div>

                <div className="grid grid-cols-1 gap-12 py-16 md:grid-cols-12">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <span className="flex h-9 w-9 items-center justify-center bg-volt font-display text-sm font-bold text-ink">
                                LA
                            </span>
                            <span className="leading-none">
                                <span className="block font-display text-sm font-bold tracking-tight">LOS ANGELES</span>
                                <span className="block text-[10px] font-bold uppercase tracking-[0.3em] text-bone/50">
                                    ADA Signage Co.
                                </span>
                            </span>
                        </div>
                        <p className="mt-6 max-w-sm text-sm leading-relaxed text-bone/60">
                            ADA-compliant signage designed, fabricated, and installed across {CONTACT.area}. Federal 2010
                            ADA Standards and California Title 24 — covered by one vendor.
                        </p>
                    </div>
                    <div className="md:col-span-3">
                        <p className="mb-5 text-xs font-bold uppercase tracking-[0.25em] text-bone/50">Site</p>
                        <ul className="space-y-3">
                            {NAV.map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                        className="group inline-flex items-center gap-1.5 text-sm font-semibold text-bone/80 transition-colors duration-300 hover:text-volt"
                                    >
                                        {l.label}
                                        <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="md:col-span-4">
                        <p className="mb-5 text-xs font-bold uppercase tracking-[0.25em] text-bone/50">Contact</p>
                        <ul className="space-y-3 text-sm font-semibold text-bone/80">
                            <li data-testid="footer-phone">{CONTACT.phone}</li>
                            <li data-testid="footer-email">
                                <a href={`mailto:${CONTACT.email}`} className="transition-colors duration-300 hover:text-volt">
                                    {CONTACT.email}
                                </a>
                            </li>
                            <li>{CONTACT.location}</li>
                            <li>{CONTACT.hours}</li>
                        </ul>
                    </div>
                </div>

                <div className="overflow-hidden border-t border-boneline py-8">
                    <p className="text-outline whitespace-nowrap font-display text-[13vw] font-bold leading-none tracking-tighter md:text-[9vw]">
                        LOS ANGELES ADA
                    </p>
                    <div className="mt-8 flex flex-col justify-between gap-3 text-xs text-bone/40 md:flex-row">
                        <p>© {new Date().getFullYear()} Los Angeles ADA Signage Co. All rights reserved.</p>
                        <p>2010 ADA Standards §216 / §703 — CBC Chapter 11B — Title 24</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
